module.exports = __webpack_public_path__ + "img/china.c7baf8c6.svg";